import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from "@shadcn-in-nx/ui/dialog";
import { Input } from "@shadcn-in-nx/ui/input";
import { Search, File, Loader2 } from "lucide-react";
import { useBluelagoon } from "@bluelagoon";
import { useDebounce } from "../hooks/useDebounce";

export function FileSearchModal({ open, onOpenChange, onSelect }) {
    const [searchTerm, setSearchTerm] = useState("");
    const debouncedSearchTerm = useDebounce(searchTerm, 300);
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);

    const { call: getFilesList } = useBluelagoon({
        method: "getFilesList",
    });

    useEffect(() => {
        if (open) {
            setLoading(true);
            getFilesList({
                limit: 20,
                search: debouncedSearchTerm,
            })
                .then((response) => {
                    if (response?.files) {
                        setFiles(response.files);
                    }
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [open, debouncedSearchTerm, getFilesList]);

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-[500px]">
                <DialogHeader>
                    <DialogTitle>Search Files</DialogTitle>
                </DialogHeader>
                <div className="space-y-4">
                    <div className="relative">
                        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                        <Input
                            placeholder="Search by filename..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="pl-10"
                            autoFocus
                        />
                    </div>
                    <div className="max-h-[300px] overflow-y-auto space-y-2">
                        {loading ? (
                            <div className="flex justify-center py-8">
                                <Loader2 className="h-6 w-6 animate-spin text-gray-400" />
                            </div>
                        ) : files.length > 0 ? (
                            files.map((file) => (
                                <button
                                    key={file.id}
                                    className="w-full flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 transition-colors text-left"
                                    onClick={() => onSelect(file)}
                                >
                                    <div className="p-2 bg-gray-50 rounded-md">
                                        <File className="h-4 w-4 text-gray-500" />
                                    </div>
                                    <div className="flex-1 min-w-0">
                                        <p className="text-sm font-medium text-gray-900 truncate">
                                            {file.name}
                                        </p>
                                        <p className="text-xs text-gray-500 truncate">
                                            {(file.size / 1024).toFixed(1)} KB
                                        </p>
                                    </div>
                                </button>
                            ))
                        ) : (
                            <div className="text-center py-8 text-gray-500 text-sm">
                                No files found
                            </div>
                        )}
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
}
